import gql from "graphql-tag";

const GET_AVAILABLE_DATES = gql`
  query getAvailableDates($groupCode: String!) {
    availableDates(groupCode: $groupCode)
      @rest(
        type: "getAvailableDates"
        path: "/get_available_dates/{args.groupCode}"
        endpoint: "v1"
      ) {
      available_dates
    }
  }
`;

export { GET_AVAILABLE_DATES };
